import AdManagementAdGroup2Reducer from 'store/ad-management-adgroup2/reducers';

export default AdManagementAdGroup2Reducer;
